export default __webpack_public_path__ + "static/media/solcredit.388a7290.svg";